<ion-item>
  <ion-label class="ion-text-wrap">
    <h2>
      <strong>{{ task.Name }}</strong>
    </h2>
    <ion-chip color="primary">
      <h3>{{ task.StartDateUTC | sagaDate: 'SubmittedDateFormat' }} - {{ task.EndDateUTC | sagaDate: 'SubmittedDateFormat' }}</h3>
    </ion-chip>
  </ion-label>
</ion-item>
